{
  "greeting": {
    "salam": "Assalamu alaikum",
    "salamWithName": "Assalamu alaikum, {{name}}"
  },
  "dock": {
    "saved": "Saved",
    "savedVerses": "Saved verses",
    "tasks": "Tasks",
    "notes": "Notes"
  },
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "delete": "Delete",
    "rename": "Rename",
    "dismiss": "Dismiss",
    "loading": "Loading…",
    "reload": "Reload",
    "retry": "Retry",
    "expand": "Expand",
    "collapse": "Collapse"
  },
  "nav": {
    "appNavigation_aria": "App navigation"
  },
  "tabs": {
    "home": "Home",
    "tasks": "Tasks",
    "notes": "Notes",
    "more": "More"
  },
  "more": {
    "daily": "Daily",
    "account": "Account",
    "savedVerses": "Saved Verses",
    "qibla": "Qibla",
    "prayerTimes": "Prayer Times & Reminders",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "Managed through your Rhemn account",
    "upgrade": "Upgrade",
    "privacyPolicy": "Privacy Policy",
    "version": "Rhemn · v{{version}}",
    "back_aria": "Back",
    "deleteAccount": "Delete account"
  },
  "reflection": {
    "dismiss_aria": "Dismiss reflection"
  },
  "app": {
    "loading_aria": "Rhemn is loading",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "Manage your Rhemn Pro subscription on the web. Pro unlocks automatically here when you sign in with your subscribed account."
  },
  "header": {
    "qiblaDirection_aria": "Qibla direction",
    "prayerTimes_aria": "Prayer times",
    "prayerTimesTitle": "Prayer Times",
    "method": "Method",
    "methodHelp": "Method affects calculated times"
  },
  "search": {
    "search_aria": "Search",
    "searchLabel": "Search",
    "searchWeb_placeholder": "Search the web"
  },
  "focus": {
    "input_placeholder": "What matters most today?",
    "example_worship": "Pray with presence, not haste",
    "example_kindness": "Call my mother just to listen",
    "example_reflect": "Reflect on your intention with today's verse",
    "saveIntention_aria": "Save intention",
    "celebration": "🤲 Mashalla"
  },
  "profile": {
    "profileFallback": "Profile",
    "profileAndAccount_aria": "Profile and account",
    "profileDialog_aria": "Profile",
    "editName_aria": "Edit your name",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "Manage subscription",
    "manageSubscription_aria": "Manage your Rehmn Pro subscription",
    "anonymousAnalytics": "Anonymous analytics",
    "anonymousAnalyticsNote": "Aggregate only — never linked to you",
    "shareAnalytics_aria": "Share anonymous usage analytics",
    "signOut": "Sign Out",
    "signingOut": "Signing out…",
    "signOut_aria": "Sign out of Rehmn",
    "restorePurchases": "Restore purchases",
    "restorePurchases_aria": "Restore previous purchases"
  },
  "background": {
    "loading": "Loading background...",
    "fallbackNotice": "Using fallback image (Unsplash API unavailable)",
    "noImage": "No background image available",
    "error": "Error: {{message}}",
    "photoByOnUnsplash": "Photo by <photographer>{{name}}</photographer> on <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "Something went wrong",
    "fallbackMessage": "An unexpected error occurred."
  },
  "theme": {
    "switchToLight_title": "Switch to light mode",
    "switchToDark_title": "Switch to dark mode"
  },
  "upgradeCta": {
    "upgradeToPro": "Upgrade to Pro",
    "restorePurchases": "Restore purchases",
    "restoring": "Restoring…",
    "restoreEmpty": "No purchases found.",
    "haveACode": "Have a code?",
    "redeeming": "Opening…",
    "redeemEmpty": "No code was redeemed.",
    "pricePerMonth": "{{price}} / month",
    "pricePerYear": "{{price}} / year",
    "purchasePending": "Waiting for approval. Pro unlocks automatically once the purchase is approved.",
    "storeUnavailable": "The App Store is unreachable right now. Try again in a moment.",
    "purchaseFailed": "The purchase could not be completed. Try again in a moment."
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · 25% off your first year",
    "title": "For the hours between your prayers.",
    "body": "Voice notes that transcribe, summarize and become tasks. A day planner built around your prayer times. Notes with AI.",
    "price": "$29.99",
    "period": "for your first year",
    "priceIos": "25% off your first year",
    "terms": "Then $39.99 a year. Code {{code}} applied for you.",
    "termsIos": "Renews at the regular yearly price. Use code {{code}} in the App Store.",
    "free": "Prayer times, Qibla, the daily verse and tasks stay free.",
    "cta": "Upgrade to Pro",
    "dismiss": "Not now"
  },
  "planChooser": {
    "monthly": "Monthly",
    "yearly": "Yearly",
    "yearlyValue": "Four months on us.",
    "freeTrialMonths_one": "Free for {{count}} month, then {{price}}",
    "freeTrialMonths_other": "Free for {{count}} months, then {{price}}",
    "freeNote": "Prayer times, Qibla, the daily verse and tasks are free. Rhemn Pro adds:",
    "includes_planner": "A day plan built around the five prayers, and \"Plan my day\"",
    "includes_insights": "Quran Insights — ask any verse a question and read its context",
    "includes_reflections": "Daily-verse reflections written for the intention you set",
    "includes_notes": "Notes and voice notes, with AI cleanup and summaries",
    "includes_extras": "Saved verses, verse photo cards, streaks and the 5-day forecast",
    "renewsMonthly": "Renews every month until cancelled",
    "renewsYearly": "Renews every 12 months until cancelled",
    "continue": "Continue",
    "renewalTerms": "Payment is charged to your Apple ID at confirmation. The subscription renews automatically unless auto-renew is turned off at least 24 hours before the period ends. Manage or cancel anytime in Apple ID settings.",
    "retry": "Try again"
  },
  "streak": {
    "badge_aria": "Daily streak — {{count}} days",
    "title": "Daily streak",
    "daysWithCount": "{{count}}-day streak",
    "start": "Begin today — spend a moment with the verse or check in a prayer.",
    "prayedToday": "Prayed today",
    "readVerse": "Read today's verse",
    "autoHint": "The verse checks itself when you spend a moment with it.",
    "milestoneTitle": "{{count}} days of intention",
    "milestoneBody": "Alhamdulillah. Share the milestone — someone you love might begin too.",
    "share": "Share",
    "dismiss": "Not now",
    "cardLabel": "days of intention",
    "shareCaption": "{{count}} days of beginning with intention — rhemn.com",
    "imageSaved": "Image saved.",
    "couldNotCreateImage": "Couldn't create the image. Please try again."
  },
  "qibla": {
    "compassIcon_aria": "Compass icon",
    "title": "Qibla Direction",
    "locationUnavailable": "Location unavailable",
    "locating": "Locating…",
    "compass_aria": "Qibla compass",
    "directionN": "N",
    "directionE": "E",
    "directionS": "S",
    "directionW": "W",
    "facingQibla": "Facing the Qibla",
    "enableLiveCompass": "Enable Live Compass",
    "enableLiveCompassNote": "Uses the motion sensor so the arrow follows as you turn — not location",
    "directionToMecca": "Direction to Mecca",
    "enableLocation": "Enable location access to calculate direction",
    "hintLive": "Arrow tracks your device orientation in real time",
    "hintStatic": "Bearing from North — use with a compass for accurate direction",
    "live": "Live",
    "footerVerse": "\"So turn your face toward al-Masjid al-Haram.\" – Quran 2:144"
  },
  "legal": {
    "links_aria": "Legal",
    "termsOfUse": "Terms of Use",
    "privacyPolicy": "Privacy Policy"
  },
  "auth": {
    "signInForPro": "Sign in first — your Pro goes with you everywhere."
  },
  "integrations": {
    "row": {
      "label": "Calendars & tasks",
      "caption": "Connected",
      "subNone": "Not connected",
      "subFree": "Google Calendar, Google Tasks and more",
      "subAttention": "{{provider}} needs attention",
      "subPaused": "Sync paused"
    },
    "list": {
      "title": "Calendars & tasks",
      "subtitle": "Bring your meetings and to-dos into your day.",
      "footnote": "Rhemn reads only what it needs, and never stores your events.",
      "privacy": "Privacy policy",
      "connect": "Connect",
      "connect_aria": "Connect {{what}}",
      "checking": "Checking…",
      "loadError": "Couldn't load your connections.",
      "tryAgain": "Try again",
      "offline": "You're offline. Connect when you're back online.",
      "unavailable": "Calendars & tasks are unavailable right now.",
      "disconnected": "{{provider}} disconnected.",
      "google": {
        "name": "Google",
        "sub": "Calendar and Tasks",
        "what": "Google Calendar and Tasks"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "Tasks and projects",
        "what": "Todoist"
      },
      "apple": {
        "name": "Calendar & Reminders",
        "subNative": "On this {{device}}",
        "subSafari": "In the Rhemn app for iPhone and Mac"
      },
      "synced": "Synced {{when}}",
      "connectedSub": "Connected",
      "syncing": "Syncing…",
      "reconnectSub": "Reconnect to keep syncing",
      "errorSub": "Last sync didn't finish",
      "pausedSub": "Paused · Rhemn Pro ended"
    },
    "explainer": {
      "google": {
        "title": "Connect Google Calendar and Tasks",
        "p1Lead": "Your calendar, read-only",
        "p1Body": "Rhemn shows your events in your day and sees when you're busy. It doesn't store them.",
        "p2Lead": "Google Tasks, both ways",
        "p2Body": "The lists you choose stay in sync, so you can check things off anywhere.",
        "p3Lead": "Yours to undo",
        "p3Body": "Disconnect anytime, here or in your Google Account.",
        "footnote": "Google will show exactly what Rhemn is asking for."
      },
      "todoist": {
        "title": "Connect Todoist",
        "p1Lead": "Your projects, both ways",
        "p1Body": "The projects you choose stay in sync, so you can check things off anywhere.",
        "p2Lead": "How it maps",
        "p2Body": "Todoist priorities become Critical, High, Medium and Low. Sub-tasks deeper than one level show as steps under their top task.",
        "p3Lead": "Yours to undo",
        "p3Body": "Disconnect anytime, here or in Todoist's settings.",
        "cta": "Continue to Todoist",
        "footnote": "Todoist will ask you to confirm."
      },
      "skip": "Not now",
      "cancel": "Cancel",
      "waiting": "Waiting for {{provider}}…",
      "safariWaiting": "Finish in the new tab, then come back here.",
      "safariReopen": "Open the tab again",
      "denied": "{{provider}} didn't give access, so nothing was connected.",
      "error": "Couldn't connect to {{provider}}. Try again in a moment."
    },
    "detail": {
      "back_aria": "Back to Calendars & tasks",
      "syncNow": "Sync now",
      "intro": "Choose what Rhemn syncs. You can change this anytime.",
      "taskLists": "Task lists",
      "projects": "Projects",
      "reminders": "Reminders",
      "calendars": "Calendars",
      "rhemnCalendarSub": "Your prayer times, not counted as busy",
      "loading": "Loading…",
      "loadError": "Couldn't load your lists.",
      "emptyGoogle": "No task lists in Google Tasks.",
      "emptyTodoist": "No projects in Todoist.",
      "addError": "Couldn't add {{name}}. Try again.",
      "removed": "Removed from Rhemn. It's still in {{provider}}.",
      "undo": "Undo",
      "prayerTimes": "Add prayer times to your calendar",
      "prayerTimesSub": "Adds the five prayers to a calendar called Rhemn, for the next 7 days, so people don't book over them.",
      "prayerTimesOn": "On. Added through {{date}}.",
      "prayerTimesWaiting": "Waiting for Google…",
      "prayerTimesDenied": "Google didn't allow it. Nothing was added.",
      "prayerTimesRemoveAsk": "Remove Rhemn's prayer times from your calendar?",
      "prayerTimesKeep": "Keep them",
      "prayerTimesRemove": "Remove",
      "meetingPrompts": "Meeting prompts",
      "meetingPromptsSub": "When a meeting with a link is about to start, offer to take notes.",
      "busyFootnote": "Plan my day only sees when you're busy, never what your meetings are.",
      "todoistFootnote": "Todoist priorities become Critical, High, Medium and Low. Sub-tasks deeper than one level show as steps under their top task.",
      "reauth": "{{provider}} stopped letting Rhemn sync. This happens when access is removed or your password changes.",
      "reconnect": "Reconnect",
      "paused": "Syncing is paused because Rhemn Pro ended. Your lists stay as they were.",
      "calendarDenied": "Calendar access is off.",
      "remindersDenied": "Reminders access is off.",
      "disconnect": "Disconnect {{provider}}",
      "disconnectTitle": "Disconnect {{provider}}?",
      "disconnectBody": "Nothing is deleted in {{provider}}.",
      "disconnectRhemnCal": "Your Rhemn prayer-times calendar will be removed from Google Calendar.",
      "disconnectError": "Couldn't disconnect {{provider}}. Try again in a moment.",
      "keepLists": "Keep my lists in Rhemn",
      "keepListsSub": "They stop syncing and become regular Rhemn lists.",
      "removeLists": "Remove them from Rhemn",
      "removeListsSub": "Only the copies in Rhemn are removed.",
      "disconnecting": "Disconnecting…",
      "appleStop": "Stop using Calendar & Reminders",
      "appleStopTitle": "Stop using Calendar & Reminders?",
      "appleStopBody": "Rhemn stops showing your events and reminders. To remove its access completely, turn it off in Settings.",
      "justNow": "just now",
      "tasksScope": "Rhemn needs permission to see your Google Tasks. Reconnect and tick Tasks to allow it.",
      "calendarsLoadError": "Couldn't load your calendars.",
      "calendarsEmpty": "No calendars in this account.",
      "calendarsScope": "Rhemn needs permission to see your Google Calendar. Reconnect and tick Calendar to allow it.",
      "prayerTimesError": "Couldn't add your prayer times. Try again in a moment.",
      "remindersEmpty": "No lists in Reminders.",
      "openSettings": "Open Settings",
      "appleStopCta": "Stop using"
    },
    "locked": {
      "body": "See your meetings inside your prayer blocks, and keep Google Tasks in sync with Rhemn.",
      "googleName": "Google Calendar & Tasks"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "device"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}, synced with {{provider}}",
      "unlinkConfirm": "Remove “{{name}}” from Rhemn? It stays in {{provider}}.",
      "remove": "Remove",
      "offline": "Offline · Changes will sync to {{provider}} when you're back.",
      "stillSyncing": "Still syncing with {{provider}}…",
      "failed_one": "{{count}} change didn't reach {{provider}}.",
      "failed_other": "{{count}} changes didn't reach {{provider}}.",
      "retry": "Retry",
      "needsReconnect": "{{provider}} needs you to reconnect.",
      "paused": "Sync is paused · Rhemn Pro ended.",
      "upgrade": "Upgrade",
      "notSynced": "Not synced",
      "notSynced_aria": "Not synced to {{provider}}. Retry.",
      "remindersOff": "Rhemn can't reach Reminders. Turn it back on in Settings.",
      "dueToday": "Today",
      "dueTomorrow": "Tomorrow",
      "googleTasks": "Google Tasks"
    },
    "today": {
      "allDay": "All day",
      "more": "+{{count}}",
      "more_aria": "Show {{count}} more all-day events",
      "less_aria": "Show fewer all-day events",
      "events_aria": "Events",
      "event_aria": "{{start}} to {{end}}, {{title}}",
      "allDayEvent_aria": "All day, {{title}}",
      "untitled": "Busy",
      "now": "Now · until {{end}}",
      "until": "until {{end}}",
      "into": "· into {{prayer}}",
      "loadError": "Couldn't load your calendar.",
      "needsReconnect": "Google Calendar needs you to reconnect.",
      "scope": "Rhemn can't see your Google Calendar. Reconnect and tick Calendar to allow it.",
      "appleOff": "Rhemn can't see your calendar. Turn it back on in Settings."
    },
    "plan": {
      "mostlyMeetings": "Mostly meetings · {{duration}} free",
      "noFreeTime": "No free time",
      "aroundMeetings_one": "Planned around {{count}} meeting.",
      "aroundMeetings_other": "Planned around {{count}} meetings.",
      "settledBusy": "Everything already fits around your meetings."
    },
    "meeting": {
      "group_aria": "Meeting starting",
      "now": "now",
      "takeNotes": "Take notes",
      "takeNotes_aria": "Take notes for {{title}}",
      "dismiss_aria": "Dismiss",
      "announce": "{{title}} starts {{when}}.",
      "announceNow": "{{title}} is starting now.",
      "yourMeeting": "Your meeting"
    },
    "apple": {
      "primer": {
        "title": "Show your calendar beside your prayers",
        "body": "Rhemn reads the events and reminders on this {{device}} to place them in your day. They stay on your device. Plan my day only uses the times you're busy.",
        "cta": "Continue",
        "skip": "Not now",
        "footnote": "{{device}} will ask twice, once for Calendar and once for Reminders. You can change either in Settings."
      }
    }
  }
}
